import React, { useEffect } from "react";
import PropTypes from "prop-types";

import { Button, Box } from "shipnow-mercurio";
import { useFormikContext } from "formik";
import { Grid } from "@mui/material";

import {
  CheckboxFormik,
  InputFormik,
  SelectFormik,
} from "../../../common/components";
import { SEARCH_CP } from "../../../common/constants/links.consts";
import { ARGENTINA_STATES } from "../../../common/constants/settings.consts";
import { StreetNumberField } from "..";
const DEFAULT_PROPS = {
  disableForm: false,
  onChange: null,
  invalidCP: "",
};

export const AddressFormFormik = (props) => {
  const attrs = { ...DEFAULT_PROPS, ...props };

  const formikCtx = useFormikContext();

  const handleChange = (e) => {
    const { value, name } = e.target;

    if (attrs.onChange) {
      attrs.onChange(value, name);
    }
  };

  useEffect(() => {
    attrs.onChange &&
      attrs.onChange(formikCtx.values.checkNumber, "checkNumber");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formikCtx.values.checkNumber]);

  return (
    <>
      <SelectFormik
        disabled={attrs.disableForm}
        label="Provincia"
        margin="b-20"
        maxHeightOptions="320px"
        name="state"
        options={ARGENTINA_STATES}
        onChange={handleChange}
      />

      <Grid container spacing={3}>
        <Grid item xs={6} lg={7}>
          <InputFormik
            disabled={attrs.disableForm}
            label="Localidad o barrio"
            margin="b-20"
            name="city"
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={3}>
          <InputFormik
            disabled={attrs.disableForm}
            label="Código postal"
            margin="b-20"
            name="zip_code"
            type="number"
            errorMsg={attrs.invalidCP}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={3} lg={2}>
          <Box margin="t-26">
            <Button href={SEARCH_CP} type="link" disabled={attrs.disableForm}>
              Averiguar mi CP
            </Button>
          </Box>
        </Grid>
      </Grid>

      <InputFormik
        disabled={attrs.disableForm}
        label="Calle"
        margin="b-20"
        name="street_name"
        onChange={handleChange}
      />

      <Grid container spacing={2}>
        <Grid container item xs={6} lg={8}>
          <Grid item xs={6} lg={9}>
            <StreetNumberField
              disabled={attrs.disableForm}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={6} lg={3}>
            <Box margin="t-20">
              <CheckboxFormik
                label="Sin número"
                name="checkNumber"
                disabled={attrs.disableForm}
              />
            </Box>
          </Grid>
        </Grid>

        <Grid item xs={3} lg={2}>
          <InputFormik
            disabled={attrs.disableForm}
            isOptional
            label="Piso"
            margin="b-20"
            name="floor"
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={3} lg={2}>
          <InputFormik
            disabled={attrs.disableForm}
            isOptional
            label="Depto"
            margin="b-24"
            name="unit"
            onChange={handleChange}
          />
        </Grid>
      </Grid>
    </>
  );
};

AddressFormFormik.propTypes = {
  disableForm: PropTypes.bool,
  onChange: PropTypes.func,
  invalidCP: PropTypes.string,
};
